import axios from 'axios';
import FormData from 'form-data';

const url = process.env.REACT_APP_MAIL_URL as string;

export const sendMail = async (data) => {
  let formData = new FormData();

  const transformedData = (data instanceof Map) ? data : new Map(Object.entries(data));

  for (let entry of transformedData) {
    formData.append(entry[0], entry[1]);
  }

  try {
    const res = await axios({
      method: 'post',
      url: url,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return res.status;
  } catch (err) {
    console.warn(err);
    return [];
  }
};
